// extracted by mini-css-extract-plugin
export default {"appContainer":"App_appContainer__Q73Qs","deactivatedMessage":"App_deactivatedMessage__aF9Ec"};